import React, { useState, useEffect } from 'react';
import api from '../../api/api';
import AdminLayout from '../../components/AdminLayuot'; // ✅ Usamos el Layout

// Constante para definir la fecha de corte (Ocultar pedidos muy viejos en el selector)
const CUTOFF_DATE = new Date('2025-10-28T00:00:00'); 

// --- THEME STANDARDIZADO ---
const THEME = {
    primary: '#1F2937', 
    secondary: '#3B82F6', 
    success: '#10B981', 
    warning: '#F59E0B', 
    danger: '#EF4444', 
    bg: '#F3F4F6', 
    white: '#FFFFFF', 
    border: '#E5E7EB'
};

function AdminPredicciones() {
    const [predicciones, setPredicciones] = useState([]);
    const [usuarios, setUsuarios] = useState([]);
    const [pedidos, setPedidos] = useState([]);
    
    const [filteredPredicciones, setFilteredPredicciones] = useState([]);
    const [selectedUser, setSelectedUser] = useState('');
    const [showUnassociatedOnly, setShowUnassociatedOnly] = useState(false); 
    
    const [loading, setLoading] = useState(true);

    // --- ESTADOS MODAL ASOCIACIÓN ---
    const [showModal, setShowModal] = useState(false);
    const [selectedPrediccion, setSelectedPrediccion] = useState(null);
    const [selectedPedidoId, setSelectedPedidoId] = useState('');

    useEffect(() => {
        fetchData();
    }, []);

    // Efecto para aplicar los filtros
    useEffect(() => {
        let currentList = predicciones;

        if (showUnassociatedOnly) {
            currentList = currentList.filter(p => !p.pedidoId); 
        }

        if (selectedUser) {
            currentList = currentList.filter(p => p.usuario?.id === selectedUser);
        }

        setFilteredPredicciones(currentList);
    }, [selectedUser, predicciones, showUnassociatedOnly]); 

    const fetchData = async () => {
        try {
            const token = localStorage.getItem('token');
            const config = { headers: { Authorization: `Bearer ${token}` } };

            const [predRes, userRes, pedRes] = await Promise.all([
                api.get('/predicciones', config),
                api.get('/users', config),
                api.get('/pedidos', config)
            ]);

            // 1. Predicciones (Ordenadas por fecha MÁS CERCANA a MÁS LEJANA)
            setPredicciones(predRes.data.sort((a, b) => new Date(a.fecha) - new Date(b.fecha)));
            
            // 2. Usuarios (Solo clientes)
            setUsuarios(userRes.data.filter(u => u.rol === 'Cliente'));

            // 3. Pedidos
            setPedidos(pedRes.data);

        } catch (error) {
            console.error("Error cargando datos", error);
        } finally {
            setLoading(false);
        }
    };

    const handleOpenAssociate = (prediccion) => {
        setSelectedPrediccion(prediccion);
        setSelectedPedidoId(''); 
        setShowModal(true);
    };

    const handleAssociate = async () => {
        if (!selectedPedidoId) return alert("Selecciona un pedido");

        try {
            const token = localStorage.getItem('token');
            
            await api.patch(`/predicciones/${selectedPrediccion.id}`, {
                pedidoId: selectedPedidoId,
                asociadaAPedido: true
            }, {
                headers: { Authorization: `Bearer ${token}` }
            });

            alert("✅ Predicción vinculada correctamente");
            setShowModal(false);
            fetchData(); 

        } catch (error) {
            console.error("Error asociando", error);
            alert("Error al vincular");
        }
    };

    const getDeliveryDateInfo = (pred) => {
        const associatedPedido = pedidos.find(p => p.id === pred.pedidoId);
        
        if (pred.pedidoId && associatedPedido) {
            const entregaDate = associatedPedido.fechaEntrega ? new Date(associatedPedido.fechaEntrega) : null;
            return {
                isAssociated: true,
                deliveryDate: entregaDate ? entregaDate.toLocaleDateString() : 'Fecha no definida',
                prediccionDate: new Date(pred.fecha).toLocaleDateString()
            };
        }
        
        return {
            isAssociated: false,
            prediccionDate: new Date(pred.fecha).toLocaleDateString()
        };
    };

    // --- LÓGICA DE FILTRADO ---
    const pedidosOcupadosIds = new Set(predicciones.map(p => p.pedidoId).filter(id => id !== null));

    // --- ESTILOS ---
    const tableStyle = { width: '100%', borderCollapse: 'collapse', marginTop: 20, background: '#fff', borderRadius: 8, overflow: 'hidden', fontSize: 14 };
    const thStyle = { background: THEME.primary, color: 'white', padding: '12px 15px', textAlign: 'left' };
    const tdStyle = { padding: '12px 15px', borderBottom: `1px solid ${THEME.border}`, color: '#333', verticalAlign: 'middle' };
    const modalOverlay = { position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', background: 'rgba(0,0,0,0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000 };
    const modalContent = { background: '#fff', padding: 30, borderRadius: 12, width: 500, boxShadow: '0 4px 20px rgba(0,0,0,0.2)' };

    return (
        <AdminLayout title="🔮 Predicciones de Consumo (IA)">
            
            {/* BARRA DE FILTROS */}
            <div style={{ background: 'white', padding: 15, borderRadius: 12, display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20, boxShadow: '0 4px 6px rgba(0,0,0,0.05)', flexWrap:'wrap', gap: 15 }}>
                
                <h3 style={{ margin: 0, color: '#6B7280', fontSize: 14, textTransform: 'uppercase' }}>Filtros de Análisis</h3>
                
                <div style={{ display: 'flex', gap: 20, alignItems: 'center', flexWrap:'wrap' }}>
                    <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', fontWeight: 'bold', color: showUnassociatedOnly ? THEME.danger : THEME.primary, background: '#F3F4F6', padding: '8px 12px', borderRadius: 8 }}>
                        <input
                            type="checkbox"
                            checked={showUnassociatedOnly}
                            onChange={(e) => setShowUnassociatedOnly(e.target.checked)}
                            style={{accentColor: THEME.danger}}
                        />
                        Mostrar solo PENDIENTES
                    </label>

                    <select 
                        style={{ padding: '8px 12px', borderRadius: 8, border: `1px solid ${THEME.border}`, minWidth: 250 }}
                        value={selectedUser}
                        onChange={(e) => setSelectedUser(e.target.value)}
                    >
                        <option value="">-- Ver Todos los Clientes --</option>
                        {usuarios.map(u => (
                            <option key={u.id} value={u.id}>{u.username} {u.perfil?.restaurant ? `(${u.perfil.restaurant})` : ''}</option>
                        ))}
                    </select>
                </div>
            </div>

            {loading ? <p style={{textAlign:'center', marginTop:50}}>Cargando análisis...</p> : (
                <div style={{ background: 'white', borderRadius: 12, boxShadow: '0 4px 6px -1px rgba(0,0,0,0.1)', overflowX: 'auto' }}>
                    <table style={tableStyle}>
                        <thead>
                            <tr>
                                <th style={thStyle}>Fecha Real/Predicha</th> 
                                <th style={thStyle}>Cliente</th>
                                <th style={thStyle}>Estimación (Kg)</th>
                                <th style={thStyle}>Estado</th>
                                <th style={thStyle}>Acción</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredPredicciones.length === 0 ? (
                                <tr><td colSpan="5" style={{padding:30, textAlign:'center', color:'#999'}}>No hay predicciones que coincidan.</td></tr>
                            ) : (
                                filteredPredicciones.map(pred => {
                                    const dateInfo = getDeliveryDateInfo(pred); 
                                    
                                    return (
                                        <tr key={pred.id} style={{ background: pred.pedidoId ? '#F0FDF4' : '#fff' }}>
                                            <td style={tdStyle}>
                                                <div style={{fontWeight: 'bold', color: THEME.primary}}>
                                                    {dateInfo.isAssociated 
                                                        ? `📅 Entrega: ${dateInfo.deliveryDate}`
                                                        : `🔮 ${dateInfo.prediccionDate}`}
                                                </div>
                                                {dateInfo.isAssociated && (
                                                    <div style={{fontSize:11, color:'#64748b'}}>Predicha originalmente: {dateInfo.prediccionDate}</div>
                                                )}
                                            </td>
                                            <td style={tdStyle}>
                                                <div style={{fontWeight:'bold'}}>{pred.usuario?.username}</div>
                                                <div style={{fontSize:11, color:'#64748b'}}>{pred.usuario?.perfil?.restaurant}</div>
                                            </td>
                                            <td style={tdStyle}>
                                                <span style={{background: '#EFF6FF', color: THEME.secondary, padding: '4px 8px', borderRadius: 6, fontWeight: 'bold'}}>
                                                    {Number(pred.cantidad).toFixed(1)} Kg
                                                </span>
                                            </td>
                                            <td style={tdStyle}>
                                                {pred.pedidoId ? (
                                                    <span style={{color: '#166534', fontWeight:'bold', fontSize:12, background: '#DCFCE7', padding: '4px 8px', borderRadius: 6}}>✅ CUBIERTA</span>
                                                ) : (
                                                    <span style={{color: '#ca8a04', fontWeight:'bold', fontSize:12, background: '#FEF9C3', padding: '4px 8px', borderRadius: 6}}>⏳ PENDIENTE</span>
                                                )}
                                            </td>
                                            <td style={tdStyle}>
                                                {!pred.pedidoId && (
                                                    <button 
                                                        onClick={() => handleOpenAssociate(pred)}
                                                        style={{padding:'6px 12px', background: THEME.secondary, color:'#fff', border:'none', borderRadius:6, cursor:'pointer', fontWeight:'bold', fontSize:12}}
                                                    >
                                                        🔗 Asociar Pedido
                                                    </button>
                                                )}
                                                {pred.pedidoId && <span style={{fontSize:11, color:'#9CA3AF'}}>ID: {pred.pedidoId.split('-')[0]}...</span>}
                                            </td>
                                        </tr>
                                    )
                                })
                            )}
                        </tbody>
                    </table>
                </div>
            )}

            {/* --- MODAL DE ASOCIACIÓN --- */}
            {showModal && selectedPrediccion && (
                <div style={modalOverlay}>
                    <div style={modalContent}>
                        <h3 style={{color: THEME.primary, marginBottom: 15, marginTop: 0}}>Vincular Pedido Real</h3>
                        
                        <div style={{background:'#F8FAFC', padding:15, borderRadius:8, marginBottom:20, fontSize:13, border: `1px solid ${THEME.border}`}}>
                            <div style={{marginBottom: 5}}><strong>Cliente:</strong> {selectedPrediccion.usuario?.username}</div>
                            <div style={{marginBottom: 5}}><strong>Fecha Estimada:</strong> {new Date(selectedPrediccion.fecha).toLocaleDateString()}</div>
                            <div><strong>Demanda Estimada:</strong> {selectedPrediccion.cantidad} Kg</div>
                        </div>

                        <label style={{display:'block', marginBottom:8, fontWeight:'bold', color: THEME.primary, fontSize: 13}}>Selecciona el Pedido Real:</label>
                        <select 
                            style={{width:'100%', padding:10, borderRadius:6, border:`1px solid ${THEME.border}`, marginBottom:20}}
                            value={selectedPedidoId}
                            onChange={(e) => setSelectedPedidoId(e.target.value)}
                        >
                            <option value="">-- Seleccionar Pedido --</option>
                            {pedidos
                                .filter(p => p.usuario?.id === selectedPrediccion.usuario?.id)
                                .filter(p => !pedidosOcupadosIds.has(p.id)) 
                                .filter(p => {
                                    const orderDate = new Date(p.fechaEntrega || p.createdAt);
                                    return orderDate >= CUTOFF_DATE;
                                })
                                .sort((a, b) => {
                                    const dateA = new Date(a.fechaEntrega || a.createdAt);
                                    const dateB = new Date(b.fechaEntrega || b.createdAt);
                                    return dateA - dateB; 
                                })
                                .map(p => {
                                    // Cálculo robusto: Intenta leer el nuevo formato (cantidadGrano) o el viejo (solicitudPedido)
                                    const totalKg = (Number(p.cantidadGrano)||0) + (Number(p.cantidadMolido)||0);
                                    
                                    const displayDate = p.fechaEntrega 
                                        ? `ENTREGA: ${new Date(p.fechaEntrega).toLocaleDateString()}`
                                        : `CREACIÓN: ${new Date(p.createdAt).toLocaleDateString()}`;
                                    
                                    return (
                                        <option key={p.id} value={p.id}>
                                            {displayDate} - {totalKg.toFixed(1)} Kg 
                                            {p.entregado ? ' (Entregado)' : ' (Pendiente)'}
                                        </option>
                                    )
                                })
                            }
                        </select>

                        <div style={{display:'flex', justifyContent:'flex-end', gap:10}}>
                            <button onClick={() => setShowModal(false)} style={{padding:'10px 20px', background:'#E5E7EB', color:'#374151', border:'none', borderRadius:6, cursor:'pointer'}}>Cancelar</button>
                            <button onClick={handleAssociate} style={{padding:'10px 20px', background: THEME.success, color:'#fff', border:'none', borderRadius:6, cursor:'pointer', fontWeight:'bold'}}>Guardar Vínculo</button>
                        </div>
                    </div>
                </div>
            )}

        </AdminLayout>
    );
}

export default AdminPredicciones;